import React from "react";
import { AppRoutes } from "./routes/AppRoutes";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider, CssBaseline } from "@mui/material";
import { createAppTheme } from "./theme";
import { ThemeModeProvider, useThemeMode } from "./context/ThemeModeContext";
import { UserSettingsProvider } from "./context/UserSettingsContext";

const AppThemeManager = () => {
	const { mode } = useThemeMode();
	const theme = React.useMemo(() => createAppTheme(mode), [mode]);

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<AppRoutes />
		</ThemeProvider>
	);
};

const App = () => {
	return (
		<AuthProvider>
			<ThemeModeProvider>
				<UserSettingsProvider>
					<AppThemeManager />
				</UserSettingsProvider>
			</ThemeModeProvider>
		</AuthProvider>
	);
};

export default App;
